// extracted by mini-css-extract-plugin
export default {"subtitle":"Subtitle_subtitle__P2g6v","button":"Subtitle_button__C3pr8","dark":"Subtitle_dark__7SJtE"};